import React from 'react';
import AppButton from '@/components/atoms/AppButton';
import BottomBar from '@/components/organisms/Footer';
import { useTheme } from '@shared/providers/theme/ThemeContext';

export interface BottomVisitClinicBarProps {
  /** 一括削除 button loading state */
  deleteLoading?: boolean;
  /** 登録 button loading state */
  storeLoading?: boolean;
  /** 当月再更新 checkbox checked state */
  otherCtlChecked?: boolean;
  /** Called when 当月再更新 checkbox changes */
  onOtherCtlChange?: (checked: boolean) => void;
  /** Called when 一括削除 is confirmed */
  onBulkDelete?: () => void;
  /** Called when 登録 is clicked */
  onStore?: () => void;
}

/**
 * BottomVisitClinicBar — Fixed bottom action bar for 施術入力 (visit_clinic/edit) page.
 *
 * Left side: 一括削除 (bulk delete) button with window.confirm confirmation (legacy A2 spec)
 * Right side: Advisory text + 当月再更新 checkbox + 登録 (store) button
 */
const BottomVisitClinicBar: React.FC<BottomVisitClinicBarProps> = ({
  deleteLoading = false,
  storeLoading = false,
  onBulkDelete,
  onStore,
}) => {
  const { colors } = useTheme();
  return (
    <BottomBar
      variant="action"
      fixed
      right={
        <div className="flex gap-4">
          <AppButton
            type="primary"
            loading={deleteLoading}
            disabled={storeLoading}
            onClick={() => onBulkDelete?.()}
            icon={<i className="fa fa-trash-o" aria-hidden="true" />}
            className="px-4 py-2 font-medium text-white bg-blue-400 rounded hover:!bg-blue-500 disabled:bg-blue-300 disabled:text-white disabled:cursor-not-allowed"
          >
            削除
          </AppButton>
          <AppButton
            type="primary"
            onClick={onStore}
            loading={storeLoading}
            disabled={deleteLoading}
            icon={<i className="mr-2 fa fa-paper-plane" aria-hidden="true" />}
            className="px-12 py-2 font-medium text-white rounded"
            style={{ backgroundColor: colors.secondary, borderColor: colors.secondary }}
          >
            登録
          </AppButton>
        </div>
      }
    />
  );
};

BottomVisitClinicBar.displayName = 'BottomVisitClinicBar';

export default BottomVisitClinicBar;
